import template from 'text!./transactionWizardTitle.html';
import controller from './transactionWizardTitleCtrl';

/**
 * @ngdoc component
 * @name gw-transaction-wizard-title
 *
 * @description  A component to display the title of the wizard.
 *
 */
export default {
    controller,
    template,
    bindings: {
        isQuote: '<',
        isPolicyChange: '<',
        isRenewal: '<'
    }
};